import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PeopleService } from "../../services/people/people.service";
import moment from "moment-timezone";

@Component({
  selector: 'app-talent-pool-report-modal',
  templateUrl: './talent-pool-report-modal.component.pug',
  styleUrl: './talent-pool-report-modal.component.scss',
  standalone: false
})
export class TalentPoolReportModalComponent implements OnInit {

  @Input() filter = 'All';
  @Input() start!: any;
  @Input() end!: any;
  @Output() closeEvent = new EventEmitter<string>();

  dateDropdownOptions = [
    {type: 'option', value: $localize`Custom`},
    {type: 'option', value: $localize`All`},
    {type: 'separator'},
    {type: 'heading', label: $localize`Days`},
    {type: 'option', value: $localize`Last 7 days`},
    {type: 'option', value: $localize`Last 30 days`},
    {type: 'option', value: $localize`Last 60 days`},
    {type: 'option', value: $localize`Last 90 days`},
    {type: 'option', value: $localize`Last 365 days`},
    {type: 'separator'},
    {type: 'heading', label: $localize`Calendar weeks`},
    {type: 'option', value: $localize`Current week`},
    {type: 'option', value: $localize`Last week`},
    {type: 'separator'},
    {type: 'heading', label: $localize`Calendar months`},
    {type: 'option', value: $localize`Current month`},
    {type: 'option', value: $localize`Last month`},
    {type: 'separator'},
    {type: 'heading', label: $localize`Calendar quarters`},
    {type: 'option', value: $localize`Current quarter`},
    {type: 'option', value: $localize`Last quarter`},
    {type: 'separator'},
    {type: 'heading', label: $localize`Calendar years`},
    {type: 'option', value: $localize`Current year`},
    {type: 'option', value: $localize`Last year`},
  ];
  loading = false;
  selectedDate = $localize`Last 30 days`;
  showDatesRow = false;
  selectedItems = [];
  dropdownPlaceholder = $localize`Select the report type`;
  fromDateLabel = $localize`Start Date`;
  toDateLabel = $localize`End Date`;
  showStartCalendar = false;
  showEndCalendar = false;
  startStr = '';
  endStr = '';
  disableGenerateBtn = true;
  items = [
    {
      "name": $localize`Talent pool`,
    }];

  constructor(
    private modalService: BsModalService,
    private peopleService: PeopleService,
  ) { }

  ngOnInit(): void {
    this.calculateLastDays(30);
  }

  closeModal(reason): void {
    this.modalService.hide();
    this.closeEvent.emit(reason);
  }

  reset(){
    this.selectedItems = [];
    this.items.forEach((item: any) => {item.checked = false;})
  }
  selectedItemsEmitter(items: any){
    this.disableGenerateBtn = !this.selectedItems.some((item: any) => item.checked);
  }

  calculateLastDays(days: number) {
    this.showDatesRow = false;
    this.start = moment().startOf('day').subtract(days, 'days');
    this.end = moment();
  }


  calculateCalendarDates(filter: string) {
    this.showDatesRow = false;
    switch (filter) {
      case 'currentWeek':
        this.start = moment().startOf('week');
        this.end = moment().endOf('week');
        break;
      case 'lastWeek':
        this.start = moment().subtract(1, 'weeks').startOf('week');
        this.end = moment().subtract(1, 'weeks').endOf('week');
        break;
      case 'currentMonth':
        this.start = moment().startOf('month');
        this.end = moment().endOf('month');
        break;
      case 'lastMonth':
        this.start = moment().subtract(1, 'months').startOf('month');
        this.end = moment().subtract(1, 'months').endOf('month');
        break;
      case 'currentQuarter':
        this.start = moment().startOf('quarter');
        this.end = moment().endOf('quarter');
        break;
      case 'lastQuarter':
        this.start = moment().subtract(1, 'quarters').startOf('quarter');
        this.end = moment().subtract(1, 'quarters').endOf('quarter');
        break;
      case 'currentYear':
        this.start = moment().startOf('year');
        this.end = moment().endOf('year');
        break;
      case 'lastYear':
        this.start = moment().subtract(1, 'years').startOf('year');
        this.end = moment().subtract(1, 'years').endOf('year');
        break;
    }
  }


  optInDateDropdownChange(event: any) {
    const value = event.value;
    this.selectedDate = value;
    this.filter = value;

    if (value === $localize`Custom`) {
      this.showDatesRow = true;
      this.start = moment().startOf('day').subtract(30, 'days');
      this.end = moment();
    } else {
      this.showDatesRow = false;
    }

    if (value === $localize`All`) {
      this.start = moment('1970-01-01T00:00:00.000');
      this.end = moment();
    }

    // Match days filters
    const daysMap = {
      [$localize`Last 7 days`]: 7,
      [$localize`Last 30 days`]: 30,
      [$localize`Last 60 days`]: 60,
      [$localize`Last 90 days`]: 90,
      [$localize`Last 365 days`]: 365
    };

    if (value in daysMap) {
      this.calculateLastDays(daysMap[value]);
    }

    // Match calendar-based filters
    const calendarFilters = [
      { label: $localize`Current week`, key: 'currentWeek' },
      { label: $localize`Last week`, key: 'lastWeek' },
      { label: $localize`Current month`, key: 'currentMonth' },
      { label: $localize`Last month`, key: 'lastMonth' },
      { label: $localize`Current quarter`, key: 'currentQuarter' },
      { label: $localize`Last quarter`, key: 'lastQuarter' },
      { label: $localize`Current year`, key: 'currentYear' },
      { label: $localize`Last year`, key: 'lastYear' },
    ];

    const selectedFilter = calendarFilters.find(f => f.label === value);
    if (selectedFilter) {
      this.calculateCalendarDates(selectedFilter.key);
    }
  }

  onCalendarVisibilityChange(event: { showStart: boolean; showEnd: boolean }) {
    this.showStartCalendar = event.showStart;
    this.showEndCalendar = event.showEnd;
  }

  onDateChange(dates: { start: moment.Moment, end: moment.Moment }) {
    this.start = dates.start;
    this.end = dates.end;
  }

  generateReport(): void{
    const data = {
      'report_types': ['talent_pool'],
      'from_date': moment(this.start).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
      'to_date': moment(this.end).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
      'timezone': moment.tz.guess(),
    };
    this.loading = true;
    this.peopleService.generateTalentPoolReport(data).subscribe({
      next: (data) => {
         this.loading = false;
         this.closeModal('generate-report-clicked');
      },
      error: (error) => {
        this.loading = false;
        console.error('Failed to generate report:', error);
        // Could emit error event or show error message
      }
    });
  }
}
